import React, {useEffect,useState, useRef} from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { optionProductsByProducts} from '../Options'
import Sidebar from '../Sidebar'
 
export default function EditPage() {
  const [price, setPrice] = useState({})
  const [date, setDate] = useState('')
  const [dateformat, setDateformat] = useState('')
  const [product_id, setProductID] = useState()
  const [product, setProduct] = useState()
  const [by_product_id, setByProductID] = useState()
  const [by_product, setByProduct] = useState()
  const [province_id, setProvinceID] = useState()
  const [province, setProvince] = useState()
  const [district_id, setDistrictID] = useState()
  const [district, setDistrict] = useState()
  const [station_id, setStationID]= useState()
  const [station, setStation] = useState()
  const [minimum, setMinimum] = useState()
  const [maximum, setMaximum]= useState()
  const [arrivals, setArrivals] = useState()
  //Arrivals units
  const [arrivalsUnit, setArrivalsUnit] = useState()
  //min-max states
  const [check, setCheck] = useState(false)
  const [message, setMessage] = useState('')
  const [displayMessage, setDisplayMessage] = useState(false)
  const [success, setSuccess] = useState(false)
  //stations
  const [options, setOptions] = useState([])
  //navigation option
  const navigate = useNavigate()


  //references
  const byproductRef = useRef(null)
  const stationRef = useRef(null)
  const minRef = useRef(null)
  const maxRef = useRef(null)
  const batchRef = useRef(null)

  //handler for product-byproduct
  const handleSelectChange = (event) => {
    const selectedName = event.target.value;
    // Find the selected option based on its name
    const selectedOption = optionProductsByProducts.find(option => option.name === selectedName);
  
    // Ensure that the selectedOption is valid before setting state
    if (selectedOption) {
      setByProduct(selectedOption.name); 
      setByProductID(selectedOption.value); 
      setProduct(selectedOption.product);
      setProductID(selectedOption.product_id);
    } else {
      console.log("Selected option not found!");
    }
  };

  //stations
  const ferrit = async() =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/getLookup`,{
      headers: {
        'x-access-token': token
      }
    })
    const data = await response.json()
    setOptions(data)
  }

  useEffect(()=>{
    ferrit()
  },[])
  
  //function to set province, district station just through stations code
  const handleStationChange = (event) => {
    const selectedName = event.target.value;
    const selectedOption = options.find(option => option.name === selectedName);
    setStation(selectedName);
    setStationID(String(selectedOption.value));
    setProvince(selectedOption.province);
    setProvinceID(String(selectedOption.province_id));
    setDistrict(selectedOption.district)
    setDistrictID(String(selectedOption.district_id));
    console.log(station + " " + station_id + "  "+ province + " " +province )
  };

  useEffect(() => {
    console.log(station + " " + station_id + "  " + province + " " + province_id +" " + district_id + " " + district);
  }, [station, station_id, province, province_id]);


  //function for min-max
  const minMax = () => {
    if (minimum !== null && maximum !== null && minimum !== '' && maximum !== '') {
      if (Number(minimum) > Number(maximum)) {
        setMessage('Minimum cannot be greater than maximum');
        setDisplayMessage(true)
        setCheck(false);
      } else {
        setDisplayMessage(false)
        setCheck(true);
      }
    } else {
      setCheck(false);
    }
  }; 
  
  const handleMinimumChange = (e) =>{
    setMinimum(parseFloat(e.target.value))
    console.log(minimum)
}

const handleMaximumChange = (e) => {
    setMaximum(parseFloat(e.target.value))
    console.log(maximum)
}

const handleArrivalsChange =(e) =>{
  setArrivals(parseFloat(e.target.value))
  console.log(arrivals)
}

  useEffect(() => {
    minMax()
  }, [minimum, maximum])

  // Use useEffect to log the state whenever the state variables change
  useEffect(() => {
    console.log(product + " " + by_product + " " + product_id + " " + by_product_id);
  }, [product, by_product, product_id, by_product_id])

   // Set the default value to today's date in "YYYY-MM-DD" format
  //  useEffect(() => {
  //   const today = new Date().toISOString().split('T')[0];
  //   setDate(today);
  // }, []);
  
  //date formatting fixture
  function formatDateToYYYYMMDD(inputDate) {
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(dateObject.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }
  const {_id} = useParams()
  const gerrit = async () =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/prices/${_id}`,{
      headers: {
        'x-access-token': token
      }
    })
    const data = await response.json()
    setPrice(data)
    setDate(data.date)
    setProductID(data.product_id)
    setProduct(data.product)
    setByProduct(data.by_product)
    setByProductID(data.by_product_id)
    setProvinceID(data.province_id)
    setProvince(data.province)
    setDistrictID(data.district_id)
    setDistrict(data.district)
    setStationID(data.station_id)
    setStation(data.station)
    setMinimum(data.minimum)
    setMaximum(data.maximum)
    setArrivals(data.arrivals)
    setArrivalsUnit(data.arrivalsUnit)
    setDateformat(formatDateToYYYYMMDD(data.date));
  }

  useEffect(()=>{
    gerrit()
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    const variables = [date, product_id,product,by_product_id,by_product,province_id,province,district_id, station_id,station,minimum,maximum];
    if (variables.every((variable) => typeof variable === 'undefined')) {
      return alert('No field should be empty');
    } 

    if (variables.some((variable) => typeof variable === 'undefined')) {
      return alert('No field should be empty 2')
    } 
    const price = {
      date: date,
      product_id: product_id,
      product: product,
      by_product_id : by_product_id ,
      by_product: by_product ,
      province_id: parseInt(province_id),
      province: province ,
      district_id: district_id,
      station_id: station_id,
      station: station,
      minimum: minimum,
      maximum: maximum,
      arrivals: arrivals,
      arrivalsUnit: arrivalsUnit
     }
  
    const token = sessionStorage.getItem('token')
    
    fetch(`${process.env.REACT_APP_API_URL}/admin/prices/${_id}`, {
      method: 'PUT',
      headers: {"Content-Type" : "application/json",
    'x-access-token':token},
      body: JSON.stringify(price)
    }).then(() => {
      navigate("/prices")
     
    }).catch((err) => {
      console.log("Unable to add record" + err);
    });

    
  };

  useEffect(()=>{
    console.log("Here is the date for purposes of checking",date)
  },[date])
  
  return (
    <>
    <div className="sidebar">
    <Sidebar/>
  </div>
    <div>
      <form onSubmit={handleSubmit} className='needs-validation' >
      {/**Rest of the form */}
      {/**Date */}
      <div>
      <div className="mb-3" id="bydrop">
        <label htmlFor="date" className="form-label">
        Date
        </label>
        <input
          id="num-value"
          type="date"
          className="form-control"
        min={0}
        value={date.split('T')[0]} // Use the formatted date as the input value
              required
              onChange={(e) => setDate(e.target.value)} // Update the date state on change
        />
      </div>
    </div>


   
    {/**By product dropdown */}
    <label for="exampleFormControlTextarea1" class="form-label" id="drop-downs">By Product</label>
      <div className="input-group mb-3"  id='drop-downs'>
        <select className="form-select" id="inputGroupSelect04" aria-label="Example select with button addon" onChange={handleSelectChange} ref={byproductRef}required >
          <option value={by_product_id}>{by_product}</option>
          {optionProductsByProducts.map((optionProductsByProduct) => (
            <option key={optionProductsByProduct.value} value={optionProductsByProduct.name}>
              {optionProductsByProduct.name}
            </option>
          ))}
        </select>
      </div>

{/**Station Dropdown*/}
<label for="exampleFormControlTextarea1" class="form-label" id='drop-downs'>Station</label>
      <div className="input-group mb-3" id="drop-downs">
        <select className="form-select" id="inputGroupSelect07" required aria-label="Select example" onChange={handleStationChange} ref={stationRef}>
          <option value={station_id}>{station}</option>
          {options.map((option) => (
          <option key={option.value} value={option.name}>
            {option.name}
          </option>
        ))}
        </select>
      </div>

      {/**Batches */}
      <div >
        <div className="mb-3" id="values-num">
          <label for="number" className="form-label">
            Arrivals
          </label>
          <input id="num-value"type="number" value={arrivals}className="form-control" min="0" onChange={handleArrivalsChange} ref={batchRef}/>
        </div>
      </div>

      {/**Minimum Price */}
      <div >
        <div className="mb-3" id="values-num">
          <label for="number" className="form-label">
            Minimum
          </label>
          <input id="num-value"type="number" value={minimum} className="form-control" min="0" onChange={handleMinimumChange} required ref={minRef}/>
        </div>
      </div>

      {/**Maximum Price */}
      <div >
        <div className="mb-3" id="values-num" >
          <label for="number" className="form-label">
            Maximum
          </label>
          <input id="num-value"type="number" value={maximum}aria-describedby="Value should not be less than 0" className="form-control" min="0" onChange={handleMaximumChange} ref={maxRef}required/>
        </div>
      </div>

      <div>
      {/**Minimum Price */}
        <div className="mb-3" id="values-num">
          <label for="number" className="form-label">
            Arrivals Unit
          </label>
          <input id="num-value"type="number" value={arrivalsUnit} className="form-control" min="0" onChange={(e)=>setArrivalsUnit(e.target.value)} ref={minRef}/>
        </div>

     </div>
             {/**Submit Button */}
      {check && <button type="submit" id ="button-submit"className=" btn btn-secondary btn-lg">Submit</button>}
      {/**Error if min and max values are not agreeing */}
      {displayMessage && <div class="alert alert-danger" id ="button-submit"role="alert">
            Minimum value cannot be greate than maximum value
      </div>}
      </form>
    </div>
    <div>
    {success && <div id="success-msg"class="card">
    <div class="card-body">
    <div class="jumbotron jumbotron-fluid">
    <div class="container">
      <p class="lead"><strong>Update successful</strong></p>
      {/* <p id='success-msg1' class='lead'>Station: <strong>{sSubmit}</strong></p>
      <p id='success-msg1'class='lead'>By product: <strong>{pSubmit}</strong></p> */}
    </div>
  </div>
    </div>
  </div>}
  </div></>
  )
}
